import LlLogo from "../../images/ll-logo.png";

export const Footer = () => {
  return (
    <div className="footer">
      <img className="footer-logo" src={LlLogo} alt="Luke Lawn's Logo" />
    </div>
  );
};
